import { render, staticRenderFns } from "./ResultDiagramMainChannel.vue?vue&type=template&id=7863a86e&scoped=true&"
import script from "./ResultDiagramMainChannel.vue?vue&type=script&lang=js&"
export * from "./ResultDiagramMainChannel.vue?vue&type=script&lang=js&"
import style0 from "./ResultDiagramMainChannel.vue?vue&type=style&index=0&id=7863a86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7863a86e",
  null
  
)

export default component.exports